import { DateTime } from 'luxon'

import { Account } from '@/core/api/entities/account/account'
import { Playlist } from '@/core/api/entities/playlist/playlist'
import { FeedbackType } from '@/core/api/entities/song/feedbackType'
import { Song } from '@/core/api/entities/song/song'
import { User } from '@/core/api/entities/user'
import { Zone } from '@/core/api/entities/zone/zone'

export class SongFeedback {
	songId: number
	feedbackTypeId: number
	playlistId: number
	accountId: number
	userId: number | null
	playerId: number | null
	createdAt: DateTime

	// Relations
	feedbackType?: FeedbackType
	user?: User
	playlist?: Playlist
	song?: Song
	account?: Account
	player?: Zone
	constructor(data: {
		songId: number
		feedbackTypeId: number
		playlistId: number
		accountId: number
		userId: number | null
		playerId: number | null
		createdAt: DateTime
		feedbackType?: FeedbackType
		user?: User
		playlist?: Playlist
		song?: Song
		account?: Account
		player?: Zone
	}) {
		this.songId = data.songId
		this.feedbackTypeId = data.feedbackTypeId
		this.playlistId = data.playlistId
		this.accountId = data.accountId
		this.userId = data.userId
		this.playerId = data.playerId
		this.createdAt = data.createdAt

		this.feedbackType = data.feedbackType ?? undefined
		this.user = data.user ?? undefined
		this.playlist = data.playlist ?? undefined
		this.song = data.song ?? undefined
		this.account = data.account ?? undefined
		this.player = data.player ?? undefined
	}

	static create(data: Partial<SongFeedback>): SongFeedback {
		const defaultData = {
			songId: 0,
			feedbackTypeId: 0,
			playlistId: 0,
			accountId: 0,
			userId: null,
			playerId: null,
			createdAt: DateTime.now(),
		}

		return new SongFeedback({
			...defaultData,
			...data,
		})
	}
}
